<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" min-height="500" persistent width="300">
      <v-card>
        <v-card-text>
          <v-text-field
            autofocus
            v-model="currentSupplier.title"
            :label="$t('suppliers_table.title')"
          ></v-text-field>
          <v-text-field v-model="currentSupplier.short_title" :label="$t('suppliers_table.short_title')"></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="creating"
            :disabled="!requiredFieldsFilled"
            color="primary"
            flat
            @click="create"
          >{{$t('problem_dialog.save')}}</v-btn>
          <v-btn color="primary" flat @click="dialog = false">{{$t('problem_dialog.cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Supplier from "@/models/Supplier.js";
export default {
  data() {
    return {
      creating: true,
      files: "",
      dialog: false,
      currentSupplier: {
        title: "",
        short_title: "",
      },
      defaultSupplier: {
        title: "",
        short_title: "",
      },
      onKeyUp: (e) => {
        if (e.key === "Enter") {
          if (this.creating) {
            this.create();
          }
        }
        if (e.key === "Escape") {
          this.dialog = false;
        }
      },
    };
  },

  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    },
  },

  beforeDestroy() {
    document.removeEventListener("keyup", this.keyUpHandler);
  },

  computed: {
    requiredFieldsFilled() {
      if (!this.currentSupplier.title) return false;
      if (!this.currentSupplier.short_title) return false;
      return true;
    },
  },

  methods: {
    openCreate() {
      this.dialog = true;
      this.creating = true;
      this.currentSupplier = { ...this.defaultSupplier };
    },

    async create() {
        if(!this.requiredFieldsFilled) return;
        await Supplier.create(this.currentSupplier);
        this.currentSupplier = { ...this.defaultSupplier };
        this.dialog = false;
        this.$emit('updated');
    }
  },
};
</script>